<template>
  <div>
    <section style="margin-right: 20px; margin-top: 10px">
      <div class="box box-danger">
        <div class="box-header d-flex align-items-center">
          <h3
            class="box-title"
            style="display: inline-block; margin-right: 5px"
          >
            Current User:
            <span v-if="currUser">{{ currUser.name }}</span>
          </h3>
          <button class="btn btn-default align-middle" @click="refreshData">
            <i class="fa fa-refresh"></i>
          </button>
        </div>
        <div class="box">
          <div class="box-header">
            <h3 class="box-title">IP Range Change Requests</h3>
          </div>
          <div class="box-body">
            <table class="table table-bordered table-striped">
              <thead>
                <tr>
                  <th>Start IP</th>
                  <th>End IP</th>
                  <th>Type</th>
                  <th>Party Name</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="ip in currUserRequests" :key="ip.id">
                  <td>{{ ip.start }}</td>
                  <td>{{ ip.end }}</td>
                  <td>{{ ip.type }}</td>
                  <td>{{ ip.partyName }}</td>
                  <td>
                    <button
                      v-if="!ip.loading"
                      @click="approveRequest(ip)"
                      class="btn btn-success"
                    >
                      Approve
                    </button>
                    <button
                      v-if="!ip.loading"
                      @click="rejectRequest(ip)"
                      class="btn btn-danger"
                    >
                      Reject
                    </button>
                    <i v-if="ip.loading" class="fa fa-spinner fa-spin"></i>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      isLoading: false,
      isError: false,
      partner: "",
      assocInst: [],
      currUserRequests: [],
    };
  },
  components: {},
  computed: {
    ...mapGetters("login", ["loggedInUser"]),
    ...mapGetters("admin", ["currUser", "allOrgs"]),
    ...mapGetters("iprange", ["requests", "filter"]),
  },
  mounted() {
    // this.refreshData();
    this.$store.dispatch("iprange/setRequests");
  },
  watch: {
    currUser: {
      handler: function (val, oldVal) {
        if (val) {
          // console.log("currUser changed");
          this.refreshData();
        }
      },
      deep: true,
      immediate: true,
    },
    requests: {
      handler: function (val, oldVal) {
        if (val) {
          // console.log("requests changed");
          this.refreshData();
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    refreshData() {
      // console.log(this.currUser);
      if (!this.currUser) return;
      this.currUserRequests = this.requests.filter(
        (r) => r.username == this.currUser.username
      );

      //add "partyName" to each item by finding from allOrgs using partyId
      this.currUserRequests = this.currUserRequests.map((item) => ({
        ...item,
        partyName: this.allOrgs.find((o) => o.partyId == item.partyId).name,
      }));
      this.currUserRequests = this.currUserRequests.map((item) => ({
        ...item,
        loading: false,
      }));
    },
    async approveRequest(request) {
      request.loading = true;
      this.$store.dispatch("iprange/deleteRequest", request).then((res) => {
        // console.log(res);
        this.$store.dispatch("iprange/setRequests");
      });
    },
    rejectRequest(request) {
      request.loading = true;
      this.$store.dispatch("iprange/deleteRequest", request).then((res) => {
        // console.log(res);
        this.$store.dispatch("iprange/setRequests");
      });
    },
  },
};
</script>

<style scoped></style>

<style>
.dataTables_wrapper .dataTables_paginate .paginate_button {
  margin-left: 5px;
  margin-right: 5px;
  padding-left: 10px;
  padding-right: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/paywall/users/ApproveIpRangesPanel.vue